import { HeadlessFormProvider } from '@delmonicos/shared-design-system-react/src/contexts/headless-form.provider';
import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { GetInvoicesPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/invoices/models/inputs/get-invoices-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useFilterSearchInvoiceListContext } from '../../invoice.context';
import { InvoiceListFilterSearchFormStep1Controller } from '../invoice-list-filter-search-form-step-1/invoice-list-filter-search-form-step-1.controller';

export interface InvoiceListFilterSearchFormControllerProps {
  onError: SubmitErrorHandler<GetInvoicesPaginatedModel>;
  onSubmit: SubmitHandlerWithDirtyFields<GetInvoicesPaginatedModel>;
  onCancel: () => void;
}

export const InvoiceListFilterSearchFormController = (
  props: InvoiceListFilterSearchFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel } = props;
  const data = useFilterSearchInvoiceListContext();

  return (
    <HeadlessFormProvider<GetInvoicesPaginatedModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      item={{
        fields: ['textToSearch'],
        component: <InvoiceListFilterSearchFormStep1Controller />,
      }}
    />
  );
};
